import PropTypes from 'prop-types';

const { LP } = window;

const SearchSortOption = ({ val, active, title, context }) => {
  const divider = val === 'relevance' ? <hr /> : '';

  const handleClick = () => {
    context.executeAction(LP.module('Searches').SearchActions.setParam, {
      key: 'sort_by',
      val
    });
  };

  return (
    <li className={active ? 'active' : ''}>
      <a
        className={`clickable text-${window.LP.isPhone() ? 'xs' : 'sm'}`}
        onClick={handleClick}
      >
        {title}
      </a>
      {divider}
    </li>
  );
};

SearchSortOption.propTypes = {
  val: PropTypes.string,
  active: PropTypes.bool,
  title: PropTypes.string,
  context: PropTypes.object
};

export default SearchSortOption;
